exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-gray[data-v-a31ef360]{color:#767676!important}", ""]);

// exports
